










import { Component, Mixins } from 'vue-property-decorator'
import BasePage from '@/tcw/components/BasePage'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'

@Component({
  components: {
    TcwLayoutBasicTemplate
  }
})
export default class CommingSoon extends Mixins(BasePage) {}
